var _rect, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPendingFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    rx: 12,
    fill: "url(#paint0_linear_1706_23630)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.1868 31.8933L28.8001 27H25.1868L19.8001 31.8933C18.2935 33.2533 17.8001 35.3467 18.5335 37.24C19.2668 39.12 21.0535 40.3333 23.0668 40.3333H30.9201C32.9468 40.3333 34.7201 39.12 35.4535 37.24C36.1868 35.3467 35.6935 33.2533 34.1868 31.8933ZM29.4268 35.1867H24.5735C24.0668 35.1867 23.6668 34.7733 23.6668 34.28C23.6668 33.7867 24.0801 33.3733 24.5735 33.3733H29.4268C29.9335 33.3733 30.3335 33.7867 30.3335 34.28C30.3335 34.7733 29.9201 35.1867 29.4268 35.1867Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4667 16.7603C34.7334 14.8803 32.9467 13.667 30.9334 13.667H23.0667C21.0534 13.667 19.2667 14.8803 18.5334 16.7603C17.8134 18.6537 18.3067 20.747 19.8134 22.107L25.2001 27.0003H28.8134L34.2001 22.107C35.6934 20.747 36.1867 18.6537 35.4667 16.7603ZM29.4267 20.6403H24.5734C24.0667 20.6403 23.6667 20.227 23.6667 19.7337C23.6667 19.2403 24.0801 18.827 24.5734 18.827H29.4267C29.9334 18.827 30.3334 19.2403 30.3334 19.7337C30.3334 20.227 29.9201 20.6403 29.4267 20.6403Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1706_23630",
    x1: 27,
    y1: 0,
    x2: 27,
    y2: 54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EC8A83",
    stopOpacity: 0.86
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E03C31"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingFilled);
export default __webpack_public_path__ + "static/media/pendingFilled.2dc5b08283f7ee37c986ec1b76102907.svg";
export { ForwardRef as ReactComponent };